import EmojiVeryPoor from '~/assets/homebase/quiz/emoji-very-poor'
import EmojiPoor from '~/assets/homebase/quiz/emoji-poor'
import EmojiNeutral from '~/assets/homebase/quiz/emoji-neutral'
import EmojiWell from '~/assets/homebase/quiz/emoji-well'
import EmojiVeryWell from '~/assets/homebase/quiz/emoji-very-well'

export const ratingItems = [
  { emoji: EmojiVeryPoor, rating: 1, i18nKey: 'terrible' },
  { emoji: EmojiPoor, rating: 2, i18nKey: 'poor' },
  { emoji: EmojiNeutral, rating: 3, i18nKey: 'neutral' },
  { emoji: EmojiWell, rating: 4, i18nKey: 'good' },
  { emoji: EmojiVeryWell, rating: 5, i18nKey: 'excellent' },
] as const
